import firebaseAnalytics from 'lib/firebase';

export function logFirebaseEvent(eventName, params = {}) {
  if (!firebaseAnalytics) return;
  try {
    // eslint-disable-next-line
    const { logEvent } = require('firebase/analytics');
    logEvent(firebaseAnalytics, eventName, params);
  } catch (e) {
    // swallow — Firebase failure must not affect the main tracker
  }
}

export default { logFirebaseEvent };
